/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';

class UnpauseModal extends React.Component {
    constructor(props) {
        super(props);

        this.dismissModal = this.dismissModal.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

    }

    componentDidMount() {
        document.addEventListener('keyup', this.onKeyUp);
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.onKeyUp);
    }

    onKeyUp(e) {

        if (e.key === "Escape") {
            this.dismissModal();
        }

    }

    dismissModal(e) {
       
        this.props.dismissModal();

    }

    render() {
        let modalContent = null;

        modalContent = (
            <div className="trial-end-warning">
                <div className="close-warning" onClick={this.dismissModal} aria-label='close' role="button">
                    <i className="fa fa-times"></i>
                </div>
                <div className="warning-content">
                    <h3 style={{"fontWeight": 500}}>Reactivate Posting</h3>
                    <p>We'll turn on any paused social profiles and check any active feeds for fresh items to post.</p>
                </div>
                <div className="buttons">
                    <div className="choose-starter" onClick={this.dismissModal} role="button" aria-label="subscribe to starter">
                        Not yet
                    </div>
                    <div className="choose-basic" onClick={this.props.confirmUnpause} role="button" aria-label="subscribe to basic">
                        Activate Posting
                    </div>
                </div>
                
            </div>
        )

        return (
            <Modal
                content={modalContent}
                boxClass={"trial-end-box"}
                mainClass={"trial-end-content"} />
        );
    }
}

UnpauseModal.displayName = "UnpauseModal";

export default UnpauseModal;
